import React from "react";
import { limitNumber } from "../../utils/number";

export default function StatsCard({ stats }) {
  return stats.map((stat) => (
    <div key={stat.id} className="col-12 col-md-6 mt-3">
      <div className="card cardDashboard totalReciveable">
        <div className="text-center py-3">{stat.label}</div>
        <div className="text-center py-1" id={stat.id}>
          {stat?.value}
        </div>
      </div>
    </div>
  ));
}
